/** Shared layout token for the fixed case-lock banner (px). */
export const CASE_LOCK_BANNER_HEIGHT_PX = 48;
